import { CloselinkWordmark } from './common/icons/closelink/CloselinkWordmark';

export const Loading = () => {
    return (
        <div className="app-loading">
            <div className="spinner-content">
                <div className="img-container">
                    <CloselinkWordmark color="blue" />
                </div>

                <div className="line-wobble-placeholder"></div>
            </div>
        </div>
    );
};
